import { render, staticRenderFns } from "./ReminderListItem.vue?vue&type=template&id=f33bb64a&scoped=true&"
import script from "./ReminderListItem.vue?vue&type=script&lang=js&"
export * from "./ReminderListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33bb64a",
  null
  
)

export default component.exports